/**
 * "Próximos dias aqui": no pé das fichas de lugar e das fichas por
 * coordenada (radar, célula do CAMS, município, estação, sensor, pluviômetro,
 * rio), fora do modo — entra no "Próximos dias" e abre a ficha da previsão
 * daquele ponto. Some quando não há rodada de previsão ou o ponto está fora
 * da área.
 */
import { CalendarDays } from 'lucide-react';
import { useExportLock } from '../loop/playback';
import { closePopup } from '../map/popupControl';
import { definirModo } from './motor';
import { posicao } from './ponto';
import { usePrevisaoStore } from './store';

/** Entra no modo e abre a ficha do ponto (no painel da previsão; o balão de onde veio fecha). */
export function abrirPrevisaoAqui(lon: number, lat: number): void {
  definirModo(true);
  if (!usePrevisaoStore.getState().modo) return; // exportação em curso
  closePopup();
  usePrevisaoStore.getState().abrirPonto(lon, lat);
}

export function ProximosDiasAqui({ lon, lat }: { lon: number; lat: number }) {
  const cobre = usePrevisaoStore((s) => {
    const g = s.indice?.modelos.ifs;
    return !!g && g.rodadas.length > 0 && posicao(g.grade, lon, lat) !== null;
  });
  const modo = usePrevisaoStore((s) => s.modo);
  // Com a exportação em curso o modo não entra: o botão sai em vez de não fazer nada.
  const travado = useExportLock();
  if (!cobre || modo || travado) return null;
  return (
    <button
      type="button"
      onClick={() => abrirPrevisaoAqui(lon, lat)}
      className="mt-1.5 inline-flex min-h-9 items-center gap-1 rounded-lg border border-violet-500/60 bg-violet-500/15 px-2 text-xs text-violet-100 hover:bg-violet-500/30 focus-visible:outline-2 focus-visible:outline-violet-400 pointer-coarse:min-h-11"
    >
      <CalendarDays className="size-3.5" aria-hidden />
      Próximos dias aqui <span aria-hidden>▸</span>
    </button>
  );
}
